<div *ngIf="!working && items.length">
  <div class="p-inputgroup">
    <div *ngIf="!isArray(label)" class="p-inputgroup-addon">{{label}}</div>
    <p-dropdown class="p-inputgroup-addon-dropdown" *ngIf="isArray(label)"
      [options]="labels"
      [(ngModel)]="selectedLabel"
      (ngModelChange)="emitChange()">
    </p-dropdown>
    <p-splitButton *ngIf="items.length >= 2"
      [label]="items[0]?.label"
      [icon]="items[0]?.icon"
      (onClick)="items[0]?.command()"
      [model]="items">
    </p-splitButton>
    <p-button *ngIf="items.length == 1"
      [label]="items[0]?.label"
      (onClick)="items[0]?.command()">
    </p-button>
  </div>
</div>
<div *ngIf="working">
  <button pButton class="p-button-nonbutton" disabled="true" label="Uploading..." icon="pi pi-spinner pi-spin"></button>
</div>
<form style="display: none;">
  <input type="file" #fileInput [accept]="getFileFormats()" (change)="startUpload()" />
</form>
